export const REMEMBERED_CHILD_KEY = 'sproutly_active_child';

export function readRememberedChild(): string | null {
  try { return localStorage.getItem(REMEMBERED_CHILD_KEY); } catch { return null; }
}
export function writeRememberedChild(id: string): void {
  try { localStorage.setItem(REMEMBERED_CHILD_KEY, id); } catch { /* private mode / blocked storage: the chooser covers it */ }
}
/** The child to open on launch, or null when the parent must choose. */
export function resolveLandingChild(children: Array<{ id: string }>, remembered: string | null): string | null {
  if (children.length === 0) return null;
  if (children.length === 1) return children[0].id;
  return remembered && children.some((c) => c.id === remembered) ? remembered : null;
}
export function parentLandingPath(children: Array<{ id: string }>, remembered: string | null): string {
  if (children.length === 0) return '/parent/onboarding';
  const id = resolveLandingChild(children, remembered);
  return id ? `/parent/${id}` : '/parent/choose';
}
